var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('link',{attrs:{"rel":"stylesheet","href":"https://cdn.jsdelivr.net/npm/@mdi/font@5.8.55/css/materialdesignicons.min.css"}}),_c('MainUI',{attrs:{"msg":"Wilmax Command Center"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }